(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mm-sale-countdown')) {
    customElements.define('mm-sale-countdown', class extends HTMLElement {
      connectedCallback() {
        clearInterval(this.timer);
        this.endTime = Date.parse(this.dataset.end);
        this.parts = ['days', 'hours', 'minutes', 'seconds'].map((part) => this.querySelector('[data-countdown-part="' + part + '"]'));
        this.tick();
        if (!this.hidden) this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      tick() {
        const remaining = Math.ceil((this.endTime - Date.now()) / 1000);
        if (!Number.isFinite(remaining) || remaining <= 0 || this.parts.some((node) => !node)) {
          this.hidden = true;
          clearInterval(this.timer);
          return;
        }
        const values = [Math.floor(remaining / 86400), Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
        this.parts.forEach((node, index) => {
          const next = String(values[index]).padStart(2, '0');
          if (node.textContent !== next) node.textContent = next;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mug-scenario-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-mm-motion]');
    if (!button) return;
    const paused = button.getAttribute('aria-pressed') !== 'true';
    button.closest('[data-mm-scenarios]').dataset.paused = String(paused);
    button.setAttribute('aria-pressed', String(paused));
    button.textContent = paused ? button.dataset.resume : button.dataset.pause;
  });

  } catch(e) { console.error(e); }
})();
})();
